import {
  Component,
  input,
  computed
} from '@angular/core';

import type {
  InputSignal,
  Signal
} from '@angular/core';

import type { DividerType } from '../panel/divider.component';

export type ListSize = 'large' | 'regular' | 'compact' | 'extra-compact'

export type DividerPosition = 'top' | 'bottom' | 'between'

@Component({
  selector: 'td-wb-list',
  template: '<ng-content />',
  styleUrls: ['list.component.scss'],
  host: {
    '[attr.role]' : 'role()',
    '[class.td-wb-list__extra-compact]': 'extraCompact()',
    '[class.td-wb-list__compact]': 'compact()',
    '[class.td-wb-list__regular]': 'regular()',
    '[class.td-wb-list__large]': 'large()',
    '[class.td-wb-list__embedded]': 'embed()',
    '[class.td-wb-list__divider--bottom]': 'dividerBottom()',
    '[class.td-wb-list__divider--top]': 'dividerTop()',
    '[class.td-wb-list__divider--between]': 'dividerBetween()',
    '[class.td-wb-list__divider--bottom-secondary]': 'dividerBottomSecondary()',
    '[class.td-wb-list__divider--top-secondary]': 'dividerTopSecondary()',
    '[class.td-wb-list__divider--between-secondary]': 'dividerBetweenSecondary()'
  }
})

export class ListComponent {
  readonly listSize: InputSignal<ListSize> = input<ListSize>('regular');
  readonly itemDivider: InputSignal<DividerPosition | undefined> = input<DividerPosition | undefined>();
  readonly dividerType: InputSignal<DividerType> = input<DividerType>('primary');
  readonly embedded: InputSignal<boolean> = input<boolean>(false);
  readonly role: InputSignal<string | undefined> = input<string | undefined>('list');

  readonly extraCompact: Signal<boolean> = computed(() => this.listSize() === 'extra-compact');
  readonly compact: Signal<boolean> = computed(() => this.listSize() === 'compact');
  readonly regular: Signal<boolean> = computed(() => this.listSize() === 'regular');
  readonly large: Signal<boolean> = computed(() => this.listSize() === 'large');
  readonly embed: Signal<boolean> = computed(() => this.embedded());

  private readonly isSecondaryDivider: Signal<boolean> = computed(() => this.dividerType() === 'secondary');

  readonly dividerBottom: Signal<boolean> = computed(() => this.itemDivider() === 'bottom' && !this.isSecondaryDivider());
  readonly dividerTop: Signal<boolean> = computed(() => this.itemDivider() === 'top' && !this.isSecondaryDivider());
  readonly dividerBetween: Signal<boolean> = computed(() => this.itemDivider() === 'between' && !this.isSecondaryDivider());
  readonly dividerBottomSecondary: Signal<boolean> = computed(() => this.itemDivider() === 'bottom' && this.isSecondaryDivider());
  readonly dividerTopSecondary: Signal<boolean> = computed(() => this.itemDivider() === 'top' && this.isSecondaryDivider());
  readonly dividerBetweenSecondary: Signal<boolean> = computed(() => this.itemDivider() === 'between' && this.isSecondaryDivider());
}
